<template>
  <div class="grid-column-start-2_md grid-column-end-4_md flex flex-column justify-items-center vh75 pt-margin">
    <h1 class="mb2 font-size-8">Setup your organization</h1>
    <form
      class="flex_sm flex-end justify-content-space-between align-items-flex-end mb-margin"
      @submit.prevent="addOrganization">
      <lw-text-input
        v-validate="'required'"
        ref="organization"
        :name="'organization'"
        :label="'Organization name'"
        :size="'large c1'"
        :class="''"
        v-model="name"
        :error="errors.first('organization')"
      />
      <div><button
        class="button full-button_mb accent-button large-button mb2"
        type="submit">Next</button></div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextInput from '../livewires/TextInput'
import * as firebase from 'firebase'

export default {
  components: {
    lwTextInput: TextInput
  },
  data () {
    return {
      name: ''
    }
  },
  computed: {
    ...mapGetters([ 'user' ])
  },
  mounted () {
    this.$refs.organization.$el.children[0].focus()
  },
  methods: {
    addOrganization () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('toggleLoading', true)
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          let payload = {
            name: this.name,
            owner: this.user.id,
            members: {},
            created: updated,
            updated: updated,
            deactivated: false,
            currency: '$',
            theme: {
              background: '#DCDBD7',
              foreground: '#322E2F',
              accent: '#FF592D',
              accent2: '#0031CE'
            }
          }
          payload.members[this.user.id] = {
            username: this.user.displayName,
            avatar: this.user.avatar
          }
          this.$store.dispatch('addOrganization', payload).then(response => {
            this.$router.push({ name: 'addRoles', query: { s: response } })
          }).catch(error => {
            console.log(error)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .mb2 {
    margin-bottom: var(--line);
  }
</style>
